// libs
import React, { memo, useCallback, useMemo, useRef, useState } from 'react';

// components
import ConfirmRedirectModal from 'shared/components/ConfirmRedirect/components/ConfirmRedirectModal';

// context
import ConfirmRedirectContext from './context';

// defs
interface ConfirmRedirectProviderProps {
  children: React.ReactNode;
}

const EMPTY_FUNC = () => {
  /** DO NOTHING */
};

function Provider({ children }: ConfirmRedirectProviderProps) {
  const [canShowConfirmModal, setShowConfirmModal] = useState(false);
  const onConfirmFunc = useRef(EMPTY_FUNC);
  const onCancelFunc = useRef(EMPTY_FUNC);

  const showConfirm = useCallback(
    (onConfirm: VoidFunction, onCancel: VoidFunction = EMPTY_FUNC) => {
      onConfirmFunc.current = onConfirm;
      onCancelFunc.current = onCancel;
      setShowConfirmModal(true);
    },
    []
  );

  const onConfirm = useCallback(() => {
    onConfirmFunc.current();
  }, []);

  const onCancel = useCallback(() => {
    onCancelFunc.current();
  }, []);

  const onHide = useCallback(() => {
    setShowConfirmModal(false);
  }, []);

  const values = useMemo(
    () => ({
      showConfirm,
    }),
    [showConfirm]
  );

  return (
    <ConfirmRedirectContext.Provider value={values}>
      {children}
      {canShowConfirmModal && (
        <ConfirmRedirectModal onConfirm={onConfirm} onCancel={onCancel} onHide={onHide} />
      )}
    </ConfirmRedirectContext.Provider>
  );
}

export default memo(Provider);
